/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Mask for the exponent of a half-precision floating-point number.
*
* @module @stdlib/constants-float16-exponent-mask
* @type {uinteger16}
*
* @example
* var FLOAT16_EXPONENT_MASK = require( '@stdlib/constants-float16-exponent-mask' );
* // returns 31744
*/


// MAIN //

/**
* Mask for the exponent of a half-precision floating-point number.
*
* ## Notes
*
* The mask for the exponent of a half-precision floating-point number is an unsigned 16-bit integer with the value \\( 31744 \\), which corresponds to the bit sequence
*
* ```binarystring
* 0 11111 0000000000
* ```
*
* @constant
* @type {uinteger16}
* @default 0x7c00
* @see [IEEE 754]{@link https://en.wikipedia.org/wiki/IEEE_754-1985}
*/
var FLOAT16_EXPONENT_MASK = 0x7c00;


// EXPORTS //

module.exports = FLOAT16_EXPONENT_MASK;
